<template>
  <div class="product-detail">
    <div class="product-detail-top">
      <div>
        <ProductSlider :result="product.morePhotos" />
        <div class="social-block">
          <a
            v-for="(item, key) in obData.socLinksShared"
            :href="item.href"
            class="social-block__item"
          >
            <svg v-if="key === 'facebook'" class="social-block__facebook">
              <use xlink:href="#svg-facebook-2"></use>
            </svg>
            <!--                        <svg v-else-if="key === 'instagram'">-->
            <!--                            <use xlink:href="#svg-instagram"></use>-->
            <!--                        </svg>-->
          </a>
          <!--                    <a href="javascript:void(0)" class="social-block__item">-->
          <!--                        <svg class="social-block__pinterest">-->
          <!--                            <use xlink:href="#svg-pinterest"></use>-->
          <!--                        </svg>-->
          <!--                    </a>-->
          <!--                    <a href="javascript:void(0)" class="social-block__item">-->
          <!--                        <svg>-->
          <!--                            <use xlink:href="#svg-twitter"></use>-->
          <!--                        </svg>-->
          <!--                    </a>-->
          <!--                    <a href="javascript:void(0)" class="social-block__item">-->
          <!--                        <svg>-->
          <!--                            <use xlink:href="#svg-message"></use>-->
          <!--                        </svg>-->
          <!--                    </a>-->
        </div>
      </div>
      <div class="product-detail__block">
        <div class="product-detail-article">
          <p class="product-detail-article__text">{{ messages.article }}. {{ product.article }}</p>
          <DefLabels :result="product.labels" />
        </div>
        <div class="product-detail-name">
          <h2 class="product-detail-name__type">{{ product.type }}</h2>
          <div class="product-detail-name__title">{{ product.name }}</div>
        </div>
        <p v-if="product.previewText" class="product-detail__name" v-html="product.previewText"></p>

        <DefColors :result="product" @changeColor="changeColor" />

        <SkuSelect
          v-if="product.propsForCheck && Object.keys(product.propsForCheck).length"
          :result="product"
        />

        <DefLink
          v-if="product?.sizesTable?.length && product?.propsForCheck?.SIZES?.length"
          class="size-table-link"
          @click="handlerOpenSizeTable"
        >
          <svg class="size-table-link__icon"><use xlink:href="#svg-help"></use></svg>
          {{ messages.sizes.name }}
        </DefLink>

        <!--        <ProductSizeTable-->
        <!--          v-if="product.sizesTable && product?.propsForCheck?.SIZES?.length"-->
        <!--          :result="product.sizesTable"-->
        <!--          :messages="messages"-->
        <!--        />-->

        <ProductPromotion
          v-if="screenWidth >= 768 && product.actions"
          :result="product.actions"
          :messages="messages"
        />
        <div v-if="product.offer.price.discountPercent" class="product-detail__discount">
          {{ product.offer.price.printDiscountPercent }}
        </div>
        <div class="product-detail__price-block">
          <p v-if="product.printDiscountPercent" class="product-detail__discount">
            {{ product.printDiscountPercent }}
          </p>
          <div>
            <span
              v-if="product.offer.price.printPrice && product.offer.price.price > 0"
              class="def-price"
            >
              {{ product.offer.price.printPrice }}
            </span>
            <span v-else class="def-price__not-available">{{
              obData.messages.notAvailableText
            }}</span>
            <span
              v-if="
                product.offer.price.printPriceOld &&
                +product.offer.price.printPrice !== +product.offer.price.printPriceOld
              "
              class="def-price-old"
              >{{ product.offer.price.printPriceOld }}</span
            >
            <span
              v-if="product.offer.price.printDiscount"
              class="product-detail__saving"
              v-html="product.offer.price.printDiscount"
            ></span>
            <span
              v-else
              class="product-detail__saving"
              v-html="product.offer.price.discount"
            ></span>
          </div>
        </div>

        <DefLink
          v-if="product?.engraving && product?.engraving?.[0]"
          class="product-engraving"
          @click="handleOpenRengraving"
        >
          {{ messages?.buyWithEngraving }}
        </DefLink>

        <ProductPairControls />
        <div class="product-detail__buttons">
          <DefButtonPrimary
            v-if="obData.messages && isAvailable()"
            :big="true"
            :result="product"
            :disabled="product?.isPair && !isPairSelected"
            @click.prevent="addToBasket(product)"
          >
            <svg><use xlink:href="#svg-basket"></use></svg>
            {{ buyMessage }}
          </DefButtonPrimary>
          <SubscribeToAvailability v-else />
          <div v-if="authInfo.isAuthorized" class="product-detail__like">
            <DefLike :result="product" />
          </div>
        </div>
        <ProductPromotion
          v-if="screenWidth < 768 && product.actions"
          :result="product.actions"
          :messages="messages"
        />
        <!-- Отображать если товар есть в наличии и на складе -->
        <div v-if="isAvailable() && stores && stores.length > 0" class="product-deliveries">
          <ProductIPost v-if="isIPostAvailable" :product="product" :messages="messages" />

          <ProductCreditModal :result="product.paySystem" />
        </div>

        <div>
          <DropDown v-if="obData.delivery">
            <template #header>{{ obData.messages.howGetProduct }}</template>
            <div>
              <div v-for="item in obData.delivery" class="get-order">
                <div class="get-order__col">
                  <h5 class="get-order__header">{{ item.printName }}:</h5>
                  <!--                                    <GetToday v-if="item.code === 'STORE'" :result="product" :messages="obData.messages" ref="getToday" @click="this.$refs.getToday[0].doOpen()">-->
                  <!--                                        <template v-slot:link >-->
                  <!--                                            <span class="get-order__map" >{{ item.description }}</span>-->
                  <!--                                        </template>-->
                  <!--                                    </GetToday>-->
                  <span>{{ item.description }}</span>
                  <span>{{ messages.willDeliver }}</span>
                </div>
                <div class="get-order__col">
                  <span class="get-order__free">{{ item.price.printPrice }}</span>
                  <span class="get-order__day">{{ item.time.messages.deliveryTime }}</span>
                  <span class="get-order__day">{{ item.time.messages.deliveryArrivalTime }}</span>
                </div>
              </div>
            </div>
          </DropDown>

          <DropDown v-if="displayProperties" :active="setOpenTab('displayProperties')">
            <template #header>{{ obData.messages && obData.messages.displayProperties }}</template>
            <div>
              <div
                v-for="(item, i) in displayProperties"
                :key="i"
                class="product-description"
                :result="item"
              >
                <h5 class="product-description__title">
                  {{ item.name }}
                  <DefInformText v-if="item.filterHint">
                    <template #content>
                      <span v-html="item.filterHint" />
                    </template>
                    <svg width="24" height="24"><use xlink:href="#svg-question"></use></svg>
                  </DefInformText>
                </h5>
                <div class="product-description__values">
                  <DefLink
                    v-for="val in item.value"
                    v-if="Array.isArray(item.value)"
                    :href="item?.filterUrl"
                    class="product-props__value"
                  >
                    {{ val }}
                  </DefLink>

                  <DefLink v-else :href="item?.filterUrl" class="product-props__value">
                    {{ item.value }}
                  </DefLink>
                </div>
              </div>
            </div>
          </DropDown>

          <DropDown v-if="product.detailText" :active="setOpenTab('detailText')">
            <template #header>{{ obData.messages && obData.messages.detailText }}</template>
            <div class="choice-text" v-html="product.detailText"></div>
          </DropDown>
        </div>
        <GetToday
          v-if="isAvailable() && stores && stores.length > 0"
          :result="product"
          :messages="messages"
        />
        <!--                <drop-down>-->
        <!--                    <template v-slot:header class="shop__title">{{ obData.messages.availableInStores }}</template>-->
        <!--                    <div class="shop" v-for="store of this.storesFilteredByAmount">-->
        <!--                        <h5 class="shop__name">{{ store.title }}</h5>-->
        <!--                        <span class="shop__address">{{ store.address }}</span>-->
        <!--                    </div>-->
        <!--                </drop-down>-->
      </div>
    </div>

    <!--        <vue-popup v-model="toggleAddToBasket" :styles="{maxWidth: '790px'} ">-->
    <!--            <addToBasketModal :result="product" :messages="obData.messages" @close="close" :dataLayer="dataLayer"/>-->
    <!--        </vue-popup>-->
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import ProductSlider from '@components/sliders/ProductSlider.vue';
import DefLabels from '@components/Def/DefLabels/DefLabels.vue';
import DefColors from '@components/Def/DefColors/DefColors.vue';
import ProductPromotion from '@components/Product/ProductPromotion.vue';
import DefLike from '@components/Def/DefLike.vue';
import ProductIPost from '@components/Product/ProductIPost/ProductIPost.vue';
import ProductCreditModal from '@components/Product/ProductCredit/ProductCreditModal.vue';
import DefInformText from '@components/Def/DefInformText/DefInformText.vue';
import GetToday from '@components/Product/GetToday/GetToday.vue';
import SkuSelect from '@components/Catalog/SkuSelect.vue';
import DropDown from '@components/bootstrap/DropDown.vue';
import { screenWidth } from '@use/useDeviceInfo';
import SubscribeToAvailability from '@components/Product/SubscribeToAvailability';
import DefLink from '@components/Def/DefLink/DefLink';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import ProductPairControls from '@components/Product/ProductPair/ProductPairControls.vue';
import ProductSizeTable from '@components/Product/ProductSizeTable.vue';
import useModalAside from '@use/useModalAside/useModalAside';
import ProductRengraving from '@components/Product/ProductRengraving/ProductRengraving.vue';
import Analytics from '../../utils/Analytics';

export default {
  name: 'ProductDetail',
  components: {
    ProductPairControls,
    DefButtonPrimary,
    DefLink,
    SubscribeToAvailability,
    DropDown,
    SkuSelect,
    GetToday,
    DefInformText,
    ProductCreditModal,
    ProductIPost,
    DefLike,
    ProductPromotion,
    DefColors,
    DefLabels,
    ProductSlider,
  },
  data() {
    return {
      // toggleAddToBasket: false,
      active: false,
      open: true,
      screenWidth,
      novaPostInterval: '',
      novaPostShipDate: '',
      novaPostDeliveryDate: '',
      modalAside: useModalAside(),
      // htmlText: 'Обработчик доставки "Новая почта" <a href="http://novaposhta.ua" >http://novaposhta.ua</a>. Вес до 100 кг.'
    };
  },
  computed: {
    ...mapState({
      authInfo: ({ personal }) => personal.data?.authInfo,
      product: ({ product }) => product.data?.product,
      messages: ({ product }) => product.data?.messages,
      cities: ({ product }) => product.data?.stores?.cities,
      obData: ({ product }) => product?.data,
      stores: ({ stores }) => stores?.data?.stores,
      isPairSelected: ({ product }) => product?.data?.isPairSelected,
    }),
    ...mapGetters({
      isAvailable: 'product/isAvailable',
    }),
    dataLayer() {
      return this.obData.dataLayer.data.products[this.product?.offer?.id ?? this.product?.id];
    },
    storesFilteredByAmount() {
      return this?.stores.filter((el) => el.amount > 0);
    },
    sku() {
      for (const offerCode in this.product.offers) {
        if (this.product.offers[offerCode].current) {
          return this.product.offers[offerCode];
        }
      }
      return {
        id: 0,
      };
    },
    displayProperties() {
      return { ...this?.product?.displayProperties, ...this?.product?.offer?.displayProperties };
    },
    isIPostAvailable() {
      return (
        this.obData.delivery.find((el) => el.code === 'IPOST') &&
        !!this.cities?.find((el) => el.UF_IPOST_DELIVERY == 1)
      );
    },
    buyMessage() {
      // if (!this.product.isPair) {
      //   return this.messages.buy;
      // }
      if (this.product.isPair && !this.isPairSelected) {
        return this.messages?.selectOption;
      }
      // if (this.product.isPair && this.isPairProduct) {
      //   return this.messages.buy;
      // }
      return this.messages.buy;
    },
  },
  methods: {
    ...mapActions({
      basketAdd: 'basket/add',
      getPageData: 'product/getPageData',
      loaderStart: 'global/loaderStart',
      loaderStop: 'global/loaderStop',
    }),
    ...mapMutations({
      changeOpenSmallBasket: 'basket/changeOpenSmallBasket',
    }),
    changeColor({ detailPage }) {
      this.getPageData({ url: detailPage, changeUrl: true });
    },
    setOpenTab(value) {
      return this.obData.messages.activTabName === value;

      // if ( this.obData.messages.activTabName === value ) {
      /*   this.active = true;
                    this.open = false;
                } else if (this.obData.messages.activTabName === value ) {
                    this.active = false;
                    this.open = true;
                } */
    },
    async addToBasket(item) {
      const id = item?.offer?.id ?? item.id;

      Analytics.addToBasket(this.dataLayer);
      this.handlerClickFacebook();
      // this.handlerClickGtag();
      await this.basketAdd({ id, count: this.product?.price?.quantity });
      this.changeOpenSmallBasket(true);
    },
    handlerClickFacebook() {
      try {
        const product = this.obData.fb.data;
        fbq('track', 'AddToCart', {
          content_type: 'product',
          content_ids: product.content_ids,
          content_name: product.content_name,
          content_category: product.content_category,
          value: product.value,
          currency: product.currency,
        });
      } catch (err) {
        console.error(err);
      }
    },
    handlerClickGtag() {
      try {
        const product = this.obData.gtag.data;
        gtag('event', 'add_to_cart', {
          send_to: 'AW-440849847',
          value: product.value,
          items: product.items,
        });
      } catch (err) {
        console.error(err);
      }
    },
    async getDataForPopup() {
      try {
        this.loaderStart();
        const response = await axios(this.product.detailPageApi);
        if (response.status === 200) {
          this.obData = response.data;
          this.tmp = response.data;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loaderStop();
      }
    },
    /**
     * if product is on central store or in Kyiv
     * @see https://sova-jewels.atlassian.net/browse/LOV-193
     * */
    isOnCentralStoreAvailable() {
      return (
        !!this.cities?.find((el) => el.UF_XML_ID === '8d5a980d-391c-11dd-90d9-001a92567626') ||
        this?.stores?.filter((el) => el.amount > 0 && el.id == 62)
      );
    },
    // setNovaPostDeliveryDates() {
    //   let date = new Date();
    //   const hours = date.getHours();
    //   const minutes = date.getMinutes();
    //   const day = date.getDay();
    //   if (this.isOnCentralStoreAvailable()) {
    //     if (hours >= 12) {
    //       this.novaPostInterval = setInterval(() => {
    //         date = new Date();
    //         // console.log(seconds);
    //         const isDeadline = false;
    //         // const isDeadline = hours > 13 || (hours === 13 && minutes > 0);
    //         if (isDeadline) {
    //           if (day) {
    //           }
    //           clearInterval(this.novaPostInterval);
    //         } else {
    //         }
    //       }, 1000);
    //     } else {
    //     }
    //   } else if ([1, 2, 3, 4].includes(day)) {
    //     this.setNovaPostDeliveryDate(`${this.messages.sendAfter} 2 ${this.messages.days}`);
    //   }
    // },
    setNovaPostDeliveryDate(shipDate, deliveryDate) {
      this.novaPostShipDate = shipDate;
      this.novaPostDeliveryDate = deliveryDate;
    },
    // close() {
    //     this.toggleAddToBasket = false;
    //     this.$emit('close');
    // }
    handlerOpenSizeTable() {
      console.log(this.product.sizesTable);
      this.modalAside.show(
        ProductSizeTable,
        {
          result: this.product.sizesTable,
        },
        {
          width: '580px',
        }
      );
    },
    handleOpenRengraving() {
      this.modalAside.show(ProductRengraving, {}, { width: '580px' });
    },
  },
  beforeMount() {
    Analytics.viewDetailProduct(this.dataLayer);
  },
  mounted() {
    if (this.obData && this.product && this.product.detailPageApi) {
      this.getDataForPopup();
    }
    // this.setNovaPostDeliveryDate();

    if (App.debug) {
      console.log('Component: product-detail', this.product);
    }
  },
};
</script>

<style lang="scss" scoped>
.product-detail {
  position: relative;
  margin-bottom: 60px;
  &__left {
    width: 58.3333333333%;
  }
  &__right {
    width: 41.6666666667%;
  }
  &__block {
    //@include point-lg{
    //    max-width: 401px;
    //}
  }
  &__title {
    font-weight: 500;
    font-size: rem(20);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--text-colour-primary);
    margin-bottom: 4px;
    @include point-md {
      font-size: rem(24);
      margin-bottom: 8px;
    }
    @include point-lg {
      font-size: rem(32);
      margin-bottom: 4px;
    }
  }
  &__name {
    font-size: rem(16);
    color: var(--hyperlink-colour-secondary);
    margin-bottom: 24px;
    @include point-md {
      margin-bottom: 32px;
    }
    @include point-lg {
      font-size: rem(18);
      margin-bottom: 24px;
    }
  }
  &__saving {
    font-size: rem(12);
    line-height: 100%;
    color: #618eaf;
    @include point-md {
      font-size: rem(14);
    }
  }
  &__discount {
    margin-bottom: 2px;
    font-weight: 500;
    font-size: rem(10);
    line-height: 115%;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #c80024;
    @include point-md {
      font-size: rem(12);
    }
  }
  &__price-block {
    margin-bottom: 24px;
  }
  &__buttons {
    display: flex;
    margin-bottom: 27px;
    @include point-md {
      margin-bottom: 40px;
    }
    @include point-lg {
      margin-bottom: 48px;
    }
  }
  &__like {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border: 1px solid #dfdfdf;
    .def-like {
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
  .def-price {
    font-size: rem(18);
    margin-right: 16px;
    @include point-lg {
      font-size: rem(24);
    }
    &__not-available {
      display: inline-block;
      font-weight: 500;
      font-size: rem(18);
      color: #757575;
      height: 24px;
    }
  }
  .def-price-old {
    font-size: rem(14);
    margin-right: 16px;
    @include point-md {
      font-size: rem(18);
    }
  }
  :deep(.def-button-primary) {
    flex-grow: 1;
    svg {
      fill: #fff;
      width: 24px;
      height: 24px;
      margin-right: 9px;
    }
  }
  &__shops {
    border-bottom: 1px solid #dfdfdf;
  }
  &__discount {
    font-size: rem(14);
    color: #d80d44;
  }
  :deep(.get-today) {
    margin-top: 24px;
  }
  :deep(.def-colors) {
    margin-bottom: 20px;
  }
  :deep(.sku-selects) {
    margin-bottom: 12px;
  }
  // hyeta
  //:deep(.def-link):not(a) {
  //  pointer-events: none;
  //  text-decoration-line: none;
  //}
  :deep(.product-engraving) {
    display: inline-block;
    margin-bottom: 16px;
  }
}
.product-detail-top {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 32px;
  @include point-md {
    grid-template-columns: minmax(0, 352px) minmax(0, 1fr);
    grid-column-gap: 24px;
  }
  @include point-lg {
    grid-template-columns: minmax(0, 712px) 401px;
    grid-column-gap: 103px;
  }
}
.get-order {
  display: flex;
  justify-content: space-between;
  font-size: rem(14);
  color: #757575;
  @include point-md {
    font-size: rem(16);
  }
  &:not(:last-child) {
    margin-bottom: 16px;
  }
  &__col {
    display: flex;
    flex-direction: column;
  }
  &__col:last-child {
    text-align: right;
  }
  &__header {
    font-weight: 500;
    font-size: rem(16);
    color: var(--text-colour-primary);
    margin-bottom: 5px;
    @include point-md {
      font-size: rem(18);
    }
  }
  &__free {
    display: block;
    font-size: rem(16);
    color: var(--text-colour-secondary);
    margin-bottom: 5px;
    @include point-md {
      font-size: rem(18);
    }
  }
  &__day {
    font-weight: 500;
  }
  &__map {
    text-decoration: underline;
    text-underline-position: under;
    text-decoration-style: dashed;
  }
}
.product-description {
  display: flex;
  justify-content: space-between;
  font-size: rem(16);
  text-align: right;
  color: #757575;
  @include point-md {
    font-size: rem(18);
  }
  &:not(:last-child) {
    margin-bottom: 16px;
  }
  &__title {
    display: flex;
    align-items: center;
    font-weight: 500;
    color: var(--text-colour-primary);
  }
  &__values {
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 2px;
  }
  :deep(.def-inform-text) {
    margin-left: 10px;
  }
}
.choice-text {
  color: #757575;
  line-height: 120%;
  font-size: rem(16);
  @include point-md {
    font-size: rem(18);
  }
}
.social-block {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  @include point-md {
    margin-top: 20px;
  }
  @include point-lg {
    margin-top: 24px;
  }
  &__item {
    &:not(:last-child) {
      margin-right: 24px;
    }
    svg {
      width: 24px;
      height: 24px;
      fill: var(--border-colour-primary);
    }
  }
}
.quick-view-link {
  margin: 24px 0 32px;
  &__item {
    font-weight: 500;
    font-size: rem(12);
    letter-spacing: 0.1em;
    text-decoration-line: underline;
    text-transform: uppercase;
    color: var(--text-colour-secondary);
    &:hover {
      color: var(--text-colour-secondary);
    }
  }
}
.shop {
  font-weight: 500;
  letter-spacing: 0.08em;
  margin-bottom: 16px;
  &__title {
    text-transform: uppercase;
    color: #191918;
  }
  &__name {
    font-size: rem(18);
    color: var(--text-colour-primary);
    margin-bottom: 5px;
  }
  &__address {
    color: #757575;
  }
}
.product-deliveries {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.product-detail-article {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
  &__text {
    font-size: rem(12);
    color: #757575;
    margin-right: 8px;
    @include point-md {
      font-size: rem(14);
    }
  }
}
.product-detail-name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 24px;

  @include point-md {
    margin-bottom: 32px;
  }
  @include point-lg {
    margin-bottom: 24px;
  }
  &__type {
    width: 100%;
    font-weight: 500;
    font-size: rem(20);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--text-colour-primary);
    margin-bottom: 4px;
    @include point-md {
      font-size: rem(24);
      margin-bottom: 8px;
    }
    @include point-lg {
      font-size: rem(32);
      margin-bottom: 4px;
    }
  }

  &__title {
    font-size: rem(16);
    margin-right: 8px;
    @include point-md {
      font-size: rem(18);
    }
  }
}
.size-table-link {
  display: inline-flex;
  margin-bottom: 24px;
  &__icon {
    transition: 0.2s linear fill;
    fill: currentColor;
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }
}
</style>
